module.exports = __webpack_public_path__ + "static/DeathTigerC-1e67a883a3fe52518fb532b47282a2be.gif";